import gql from 'graphql-tag';
import { MediaBaseFragment } from './MediaBaseFragment';

export const Trend360FullFragment = gql`
	fragment Trend360FullFragment on Trend360 {
		id
		localId
		status
		trendName
		trendType
		firstDetected
		nextReview
		trendIconMedia {
			...MediaBaseFragment
		}
		heroImageMedia {
			...MediaBaseFragment
		}
		marketStatus
		origin
		monitoringStatus
		trendStatus
		evolution
		intro
		content
		signalSources
		earlySignals
		whatToMonitor
		tags
		parentMacrotrend {
			id
			localId
			trendName
		}
		antithesisTrend {
			id
			localId
			trendName
		}
		scoreEvolutionChart {
			id
			localId
			name
		}
		marketPulseSurvey {
			id
			localId
			name
		}
		communitySurvey {
			id
			localId
			name
		}
	}
	${MediaBaseFragment}
`;
